// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_hm-0";
export var fulfillmentPanelBody = "_hm-1";